import { QueryKeys } from '@/types';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useSorting() {
  const navigate = useNavigate();

  const setSort = useCallback(
    sort => {
      const urlParams = new URLSearchParams(location.search);
      if (sort?.direction === 'ASC' || sort?.direction === 'DESC') {
        urlParams.set(QueryKeys.SORT_COL, sort?.col ?? '');
        urlParams.set(QueryKeys.SORT_DIR, sort?.direction ?? '');
      } else {
        urlParams.delete(QueryKeys.SORT_COL);
        urlParams.delete(QueryKeys.SORT_DIR);
      }
      if (urlParams.toString() !== location.search.replace(/^\?/, '')) {
        navigate({ search: urlParams.toString() }, { replace: true });
      }
    },
    [navigate, location.search],
  );

  const handleSort = useCallback(
    (columnKey: string, direction: any) => {
      setSort({
        col: columnKey,
        direction,
      });
    },
    [setSort],
  );

  return handleSort;
}
